import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [accessToken, setAccessToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
//  const navigate = useNavigate();
  
  useEffect(() => {
    const storedToken = localStorage.getItem('accessToken');
    if (storedToken) {
      setAccessToken(storedToken);
      setIsLoggedIn(true);
    }
  }, []);

  const signIn = (token) => {
    setAccessToken(token);
    localStorage.setItem('accessToken', token);
    console.log("Inside signIn :", token);
  };

  const signOut = () => {
    setIsLoggedIn(false);
    setAccessToken(null);
    localStorage.removeItem('accessToken');
  };

  console.log("Header Bar signIn state :", isLoggedIn);


  const handleLogout = () => {
    setIsLoggedIn(false);
    console.log("Handle Logout :", isLoggedIn);
    signOut();
    //navigate('/');
};
  const handleLogin = () => {
    setIsLoggedIn(true);
    // Add any additional login logic here
  };

  return (
    <AuthContext.Provider value={{ accessToken, signIn, signOut, isLoggedIn, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
}